<script>import {
  addEventListener,
  executeCallbacks,
  srOnlyStyles,
  styleToString
} from "../../internal/index.js";
import { createCommand } from "../command.js";
export let label = void 0;
export let shouldFilter = true;
export let filter = void 0;
export let value = void 0;
export let onValueChange = void 0;
export let loop = void 0;
export let onKeydown = void 0;
export let state = void 0;
export let ids = void 0;
export let asChild = false;
const {
  commandEl,
  handleRootKeydown,
  ids: commandIds,
  state: stateStore
} = createCommand({
  label,
  shouldFilter,
  filter,
  value,
  onValueChange: (next) => {
    if (next !== value) {
      value = next;
      onValueChange?.(next);
    }
  },
  loop,
  state,
  ids
});
function syncValueAndState(value2) {
  if (value2 && value2 !== $stateStore.value) {
    $stateStore.value = value2;
  }
}
$: syncValueAndState(value);
function rootAction(node) {
  commandEl.set(node);
  const unsubEvents = executeCallbacks(addEventListener(node, "keydown", handleKeydown));
  return {
    destroy: unsubEvents
  };
}
const rootAttrs = {
  role: "application",
  id: commandIds.root,
  "data-cmdk-root": ""
};
const labelAttrs = {
  "data-cmdk-label": "",
  for: commandIds.input,
  id: commandIds.label,
  style: styleToString(srOnlyStyles)
};
function handleKeydown(e) {
  onKeydown?.(e);
  if (e.defaultPrevented) return;
  handleRootKeydown(e);
}
const root = {
  action: rootAction,
  attrs: rootAttrs
};
$: slotProps = {
  root,
  label: { attrs: labelAttrs },
  stateStore,
  state: $stateStore
};
</script>

{#if asChild}
	<slot {...slotProps} />
{:else}
	<div use:rootAction {...rootAttrs} {...$$restProps}>
		<!-- svelte-ignore a11y-label-has-associated-control applied in attrs -->
		<label {...labelAttrs}>
			{label ?? ''}
		</label>
		<slot {...slotProps} />
	</div>
{/if}
